export const OWN_STATUS_IDLE = 'idle';
export const OWN_STATUS_LISTENING = 'listening';
export const OWN_STATUS_SUCCESS = 'success';
export const OWN_STATUS_ERROR = 'error';
export const OWN_STATUS_WAIT_AGREE = 'wait_agree';
export const OWN_STATUS_LOADING = 'loading';

export const LISTENING_INTERVAL = 25000;